module.exports = __webpack_public_path__ + "ggcurling.7b3a2c84af431ac20744.png";